import React from 'react';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
//import Title from '../Complements/Title';
import Button from '@material-ui/core/Button';
//import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
//import QRCode from 'react-qr-code';
//import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { history } from '../../helpers/history';
//import { isMobile } from 'react-device-detect';
const useStyles = makeStyles(theme => ({
  logo: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      height: '100%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: '100%'
    },
    [theme.breakpoints.up('md')]: {
      width: '70%',
      height: '70%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '70%',
      height: '70%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '70%',
      height: '70%',
    },
  },
  logofooter: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      height: '100%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '25%',
      height: '25%'
    },
    [theme.breakpoints.up('md')]: {
      width: '25%',
      height: '25%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '25%',
      height: '25%'
    },
    [theme.breakpoints.up('xl')]: {
      width: '25%',
      height: '25%'
    },
  },
  logoallwidth: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      height: '100%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '40%',
      height: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '40%',
      height: '40%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '40%',
      height: '40%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '40%',
      height: '40%',
    },
  },
  logofooterallwidth: {
    [theme.breakpoints.up('xs')]: {
      width: '50%',
      height: '50%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '15%',
      height: '15%'
    },
    [theme.breakpoints.up('md')]: {
      width: '15%',
      height: '15%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '15%',
      height: '15%'
    },
    [theme.breakpoints.up('xl')]: {
      width: '15%',
      height: '15%'
    },
  },
  fondocabecera: {
    textAlign: "center",
  },
  fondodetalle: {
  },
  textocabecera: {
    [theme.breakpoints.up('xs')]: {
      color: '#266ca7',
      fontSize: '180%',
      fontFamily: "MyriadPro-BoldItalic",
      textAlign: 'center'
    },
    [theme.breakpoints.up('sm')]: {
      color: '#2E2757',
      fontSize: '180%',
      fontFamily: "MyriadPro-BoldItalic",
      textAlign: 'center'
    },
    [theme.breakpoints.up('md')]: {
      color: '#2E2757',
      fontSize: '140%',
      fontFamily: "MyriadPro-BoldItalic",
      textAlign: 'center'
    },
    [theme.breakpoints.up('lg')]: {
      color: '#2E2757',
      fontSize: '140%',
      fontFamily: "MyriadPro-BoldItalic",
      textAlign: 'center'
    },
    [theme.breakpoints.up('xl')]: {
      color: '#2E2757',
      fontSize: '140%',
      fontFamily: "MyriadPro-BoldItalic",
      textAlign: 'center'
    },
  },
  textocabeceradetalle: {
    color: '#000000',
    fontSize: '130%',
    textAlign: 'center',
    fontFamily: "MyriadPro-Regular"
  },
  textocabeceradetalleinvisible: {
    color: '#EEEFF2',
    fontSize: '110%',
  },
  textovalor: {
    color: '#FFFEFF',
    fontSize: '450%',
    textAlign: "center",
  },
  textovalorreduce: {
    color: '#FFFEFF',
    fontSize: '300%',
    textAlign: "center",
  },
  textotitulodetalle: {
    color: '#000000',
    fontSize: '100%',
    fontFamily: "RobotoCondensed-Regular",
  },
  textotitulodetallenegrita: {
    color: '#000000',
    fontSize: '100%',
    fontFamily: "RobotoCondensed-Regular",
  },
  texttitleone: {
    color: '#1460a0',
    fontFamily: "RobotoCondensed-Bold",
    fontSize: '80%'
  },
  texttitletwo: {
    color: '#1460a0',
    fontFamily: "RobotoCondensed-Bold",
    fontSize: '80%'
  },
  line: {
    backgroundColor: '#4BA136',
    height: '1px',
    width: '100%'
  },
  fondotexto: {
  },
  submit: {
    fontSize: '1rem',
    color: '#ffffff',
    borderRadius: '4px',
    '&.Mui-disabled': {
      backgroundColor: "#B48518",
    },
    '&:hover': {
      backgroundColor: "#B48518",
    },
    backgroundColor: "#201B3C",
    fontFamily: 'MyriadPro-Bold'
  },
  gridMonto: {
  },
  gridTexto: {
    backgroundColor: "#EEEFF2"
  },
  styleQr: {
    display: 'block',
    margin: 'auto'
  }
}));
const QrInfo = props => {
  // eslint-disable-next-line
  const classes = useStyles();
  const {
    mac,
    image,
    handlePrintProcess
  } = props;
  //console.log('mac', mac)
  return (
    <div>
      <Grid container spacing={3} alignItems="center" direction="row" justify="center">
        <Grid item xs={12} md={12}>
          <p style={{ textAlign: "center" }}>
            Muestra este código para que puedan pagarte.
          </p>
        </Grid>
        <Grid style={{
          width: '100%',
          position: 'relative',
          marginBottom: 16
        }}>
          <img src={process.env.PUBLIC_URL + '/icons/fondo_qr.png'} alt="QR Generate" style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 15 }} />
          <img src={image} alt="QR Generate" style={{ width: '75%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
        </Grid>
        <Grid container spacing={2} alignItems="center" direction="row" justifyContent="center">
          <Grid item xs={6} md={6} lg={6} sm={6}>
            <Button variant="outlined" color='primary' fullWidth onClick={handlePrintProcess}>
              {mac === "NAVEGADOR" ? 'Imprimir' : 'Compartir'}
            </Button>
          </Grid>
          <Grid item xs={6} md={6} lg={6} sm={6}>
            <Button variant="contained" color='primary' fullWidth onClick={() => history.push('/qr-generate')}>
              Generar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default QrInfo;